import { createPart } from "ag-grid-community";

export const warningCellPart = createPart({
	css: `
	  .max-limit {
		color: var(--ag-warning-cell-foreground-color);
		font-weight: var(--ag-warning-cell-font-weight);
		background-color: var(--ag-warning-cell-background-color);
	  }
	`,
	params: {
		warningCellForegroundColor: " #CC0000",
		warningCellFontWeight: 600,
		warningCellBackgroundColor: "transparent",
	},
});

export const infoCellPart = createPart({
	css: `
	  .info-limit {
		color: var(--ag-info-cell-foreground-color);
		background-color: var(--ag-info-cell-background-color);
		font-weight: var(--ag-info-cell-font-weight);
	  }
	`,
	params: {
		infoCellForegroundColor: " #000",
		infoCellBackgroundColor: " #b2e5ed",
		infoCellFontWeight: 600,
	},
});

export const monthReportCellPart = createPart({
	css: `
	  .month-report {
		background-color: var(--ag-info-cell-background-color);
	  }
	  
	  .month-report:hover {
		background-color: #DAE5EA;
	  }
	`,
	params: {
		infoCellBackgroundColor: " #E9F2F7",
	},
});

export const assetChipPart = createPart({
	css: `
    .custom-chip {
      display: inline-flex;
      align-items: center;
      padding: 4px 12px;
      border-radius: 16px;
      font-size: 0.8125rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      line-height: 1.5;
      cursor: default;
    }

    .ag-cell.eaf-11 .custom-chip {
      font-weight: 500;
      color: #192a4d;
      background-color: #dae8fc;
      border: 1px solid #a6c8f7;
    }

    .ag-cell.eaf-12 .custom-chip {
      font-weight: 500;
      color: #273d25;
      background-color: #d5e8d4;
      border: 1px solid #a3d3a1;
    }
  `,
	params: {},
});

export const labTableParts = createPart({
	css: `
	  .cell-below-min {
		background-color: #ffa500;
		font-weight: bold;
	  }

	  .cell-above-max {
		background-color: #f26b6b;
		font-weight: bold;
	  }

	  .ag-header-cell-label {
		display: flex;
		justify-content: center;
		align-items: center;
	  }
	`,
	params: {},
});
